export default __webpack_public_path__ + "static/media/american-express.b5066458.svg";